// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file booking/types/v1/order.proto (package booking.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Address } from "../../../types/v1/address_pb.js";
import { SalesChannel } from "../../../types/v1/sales_pb.js";
import { Money } from "../../../types/v1/money_pb.js";
import { Text } from "../../../types/v1/text_pb.js";
import { ShipmentMethod } from "../../../shop_config/types/v1/shipment_pb.js";

/**
 * @generated from enum booking.types.v1.SeatUpgrade
 */
export const SeatUpgrade = /*@__PURE__*/ proto3.makeEnum(
  "booking.types.v1.SeatUpgrade",
  [
    {no: 0, name: "SEAT_UPGRADE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SEAT_UPGRADE_FANTICKET", localName: "FANTICKET"},
  ],
);

/**
 * @generated from enum booking.types.v1.LineItemType
 */
export const LineItemType = /*@__PURE__*/ proto3.makeEnum(
  "booking.types.v1.LineItemType",
  [
    {no: 0, name: "LINE_ITEM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LINE_ITEM_TYPE_SEATS", localName: "SEATS"},
    {no: 2, name: "LINE_ITEM_TYPE_BUNDLE", localName: "BUNDLE"},
    {no: 3, name: "LINE_ITEM_TYPE_GIFTCARD", localName: "GIFTCARD"},
  ],
);

/**
 * @generated from message booking.types.v1.OrderPreview
 */
export const OrderPreview = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.OrderPreview",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ticket_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "customer_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_status", kind: "enum", T: proto3.getEnumType(OrderPreview_PaymentStatus) },
    { no: 6, name: "refund_status", kind: "enum", T: proto3.getEnumType(OrderPreview_RefundStatus) },
    { no: 7, name: "shipped", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
    { no: 9, name: "giftcard_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "item_counts", kind: "message", T: OrderPreview_ItemCounts },
    { no: 11, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum booking.types.v1.OrderPreview.PaymentStatus
 */
export const OrderPreview_PaymentStatus = /*@__PURE__*/ proto3.makeEnum(
  "booking.types.v1.OrderPreview.PaymentStatus",
  [
    {no: 0, name: "PAYMENT_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_STATUS_OUTSTANDING", localName: "OUTSTANDING"},
    {no: 2, name: "PAYMENT_STATUS_PAID", localName: "PAID"},
    {no: 3, name: "PAYMENT_STATUS_FAILED", localName: "FAILED"},
    {no: 4, name: "PAYMENT_STATUS_EXPIRED", localName: "EXPIRED"},
  ],
);

/**
 * @generated from enum booking.types.v1.OrderPreview.RefundStatus
 */
export const OrderPreview_RefundStatus = /*@__PURE__*/ proto3.makeEnum(
  "booking.types.v1.OrderPreview.RefundStatus",
  [
    {no: 0, name: "REFUND_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REFUND_STATUS_PARTIALLY", localName: "PARTIALLY"},
    {no: 2, name: "REFUND_STATUS_ALL", localName: "ALL"},
  ],
);

/**
 * @generated from message booking.types.v1.OrderPreview.ItemCounts
 */
export const OrderPreview_ItemCounts = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.OrderPreview.ItemCounts",
  () => [
    { no: 1, name: "tickets", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "giftcards", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "upgrades", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "OrderPreview_ItemCounts"},
);

/**
 * @generated from message booking.types.v1.Customer
 */
export const Customer = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Customer",
  () => [
    { no: 1, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "billing_address", kind: "message", T: Address },
    { no: 5, name: "shipping_address", kind: "message", T: Address },
    { no: 6, name: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "vat_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "identity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message booking.types.v1.Order
 */
export const Order = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "org_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(Order_Status) },
    { no: 5, name: "customer", kind: "message", T: Customer },
    { no: 6, name: "lines", kind: "message", T: Order_Line, repeated: true },
    { no: 7, name: "refunds", kind: "message", T: Refund, repeated: true },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "webshop_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "customer_identity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "sales_channel", kind: "enum", T: proto3.getEnumType(SalesChannel) },
    { no: 13, name: "seller_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "vat_rate", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "upgrades", kind: "message", T: Order_Upgrade, repeated: true },
    { no: 16, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "referral_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from enum booking.types.v1.Order.Status
 */
export const Order_Status = /*@__PURE__*/ proto3.makeEnum(
  "booking.types.v1.Order.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_PLACED", localName: "PLACED"},
    {no: 2, name: "STATUS_PAID", localName: "PAID"},
    {no: 3, name: "STATUS_SHIPPED", localName: "SHIPPED"},
    {no: 4, name: "STATUS_VOIDED", localName: "VOIDED"},
    {no: 5, name: "STATUS_FAILED", localName: "FAILED"},
  ],
);

/**
 * @generated from enum booking.types.v1.Order.DiscountType
 */
export const Order_DiscountType = /*@__PURE__*/ proto3.makeEnum(
  "booking.types.v1.Order.DiscountType",
  [
    {no: 0, name: "DISCOUNT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DISCOUNT_TYPE_VOUCHER", localName: "VOUCHER"},
    {no: 2, name: "DISCOUNT_TYPE_BENEFIT", localName: "BENEFIT"},
    {no: 3, name: "DISCOUNT_TYPE_GIFTCARD", localName: "GIFTCARD"},
  ],
);

/**
 * @generated from message booking.types.v1.Order.Price
 */
export const Order_Price = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.Price",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "message", T: Money },
    { no: 3, name: "name", kind: "message", T: Text },
    { no: 4, name: "vat_rate", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Order_Price"},
);

/**
 * @generated from message booking.types.v1.Order.Line
 */
export const Order_Line = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.Line",
  () => [
    { no: 1, name: "number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "items", kind: "message", T: Order_LineItem, repeated: true },
  ],
  {localName: "Order_Line"},
);

/**
 * @generated from message booking.types.v1.Order.LineItem
 */
export const Order_LineItem = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.LineItem",
  () => [
    { no: 1, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seat", kind: "message", T: Order_SeatItem, oneof: "item" },
    { no: 3, name: "bundle", kind: "message", T: Order_BundleItem, oneof: "item" },
    { no: 4, name: "shipment", kind: "message", T: Order_ShipmentItem, oneof: "item" },
    { no: 5, name: "discount", kind: "message", T: Order_DiscountItem, oneof: "item" },
    { no: 6, name: "giftcard", kind: "message", T: Order_GiftcardItem, oneof: "item" },
    { no: 7, name: "seat_upgrade", kind: "message", T: Order_SeatUpgradeItem, oneof: "item" },
    { no: 10, name: "price", kind: "message", T: Money },
    { no: 11, name: "vat_rate", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 12, name: "extensions", kind: "message", T: Order_Extension, repeated: true },
  ],
  {localName: "Order_LineItem"},
);

/**
 * @generated from message booking.types.v1.Order.SeatItem
 */
export const Order_SeatItem = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.SeatItem",
  () => [
    { no: 1, name: "series_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_name", kind: "message", T: Text },
    { no: 4, name: "section_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "section_name", kind: "message", T: Text },
    { no: 6, name: "price", kind: "message", T: Order_Price },
    { no: 7, name: "seat_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 8, name: "seat_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "row", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Order_SeatItem"},
);

/**
 * @generated from message booking.types.v1.Order.BundleItem
 */
export const Order_BundleItem = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.BundleItem",
  () => [
    { no: 1, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bundle_name", kind: "message", T: Text },
    { no: 3, name: "line_items", kind: "message", T: Order_LineItem, repeated: true },
    { no: 4, name: "price", kind: "message", T: Order_Price },
    { no: 5, name: "single_ticket", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "series_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Order_BundleItem"},
);

/**
 * @generated from message booking.types.v1.Order.DiscountItem
 */
export const Order_DiscountItem = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.DiscountItem",
  () => [
    { no: 1, name: "discount_type", kind: "enum", T: proto3.getEnumType(Order_DiscountType) },
    { no: 2, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "order_level", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Order_DiscountItem"},
);

/**
 * @generated from message booking.types.v1.Order.ShipmentItem
 */
export const Order_ShipmentItem = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.ShipmentItem",
  () => [
    { no: 1, name: "method", kind: "enum", T: proto3.getEnumType(ShipmentMethod) },
  ],
  {localName: "Order_ShipmentItem"},
);

/**
 * @generated from message booking.types.v1.Order.GiftcardItem
 */
export const Order_GiftcardItem = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.GiftcardItem",
  () => [
    { no: 1, name: "giftcard_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "giftcard_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Order_GiftcardItem"},
);

/**
 * @generated from message booking.types.v1.Order.SeatUpgradeItem
 */
export const Order_SeatUpgradeItem = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.SeatUpgradeItem",
  () => [
    { no: 1, name: "referenced_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "upgrade", kind: "enum", T: proto3.getEnumType(SeatUpgrade) },
  ],
  {localName: "Order_SeatUpgradeItem"},
);

/**
 * @generated from message booking.types.v1.Order.Extension
 */
export const Order_Extension = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.Extension",
  () => [
    { no: 1, name: "price", kind: "message", T: Money },
    { no: 10, name: "discount", kind: "message", T: Order_DiscountItem, oneof: "data" },
    { no: 11, name: "fanticket", kind: "message", T: Order_Fanticket, oneof: "data" },
  ],
  {localName: "Order_Extension"},
);

/**
 * @generated from message booking.types.v1.Order.Fanticket
 */
export const Order_Fanticket = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.Fanticket",
  [],
  {localName: "Order_Fanticket"},
);

/**
 * @generated from message booking.types.v1.Order.Upgrade
 */
export const Order_Upgrade = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Order.Upgrade",
  () => [
    { no: 1, name: "referencing_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "fanticket", kind: "message", T: Order_Fanticket, oneof: "upgrade" },
  ],
  {localName: "Order_Upgrade"},
);

/**
 * @generated from message booking.types.v1.Refund
 */
export const Refund = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Refund",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "approver_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message booking.types.v1.SeatIDs
 */
export const SeatIDs = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.SeatIDs",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
  ],
);

/**
 * OrderSeatConfig describes the order configuration of the reserved seats. It defines to
 * which section the seats are belonging and which price should be payed for them.
 *
 * @generated from message booking.types.v1.OrderSeatConfig
 */
export const OrderSeatConfig = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.OrderSeatConfig",
  () => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "seating" },
    { no: 5, name: "seat_ids", kind: "message", T: SeatIDs, oneof: "seating" },
    { no: 6, name: "upgrades", kind: "enum", T: proto3.getEnumType(SeatUpgrade), repeated: true },
  ],
);

/**
 * @generated from message booking.types.v1.SeatmapSectionID
 */
export const SeatmapSectionID = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.SeatmapSectionID",
  () => [
    { no: 1, name: "seatmap_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seatmap_section_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * OrderBundleConfig is a configuration for seats that are part of a bundle. Each configuration describes the configuration
 * for a whole bundle. A bundle can occur multiple times if it shall be ordered multiple times.
 *
 * @generated from message booking.types.v1.OrderBundleConfig
 */
export const OrderBundleConfig = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.OrderBundleConfig",
  () => [
    { no: 1, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seatmap_section_id", kind: "message", T: SeatmapSectionID, oneof: "section" },
    { no: 3, name: "ga_section_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "section" },
    { no: 4, name: "seats_by_event", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: OrderBundleConfig_Seats} },
    { no: 5, name: "price_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "upgrades", kind: "enum", T: proto3.getEnumType(SeatUpgrade), repeated: true },
  ],
);

/**
 * @generated from message booking.types.v1.OrderBundleConfig.Seats
 */
export const OrderBundleConfig_Seats = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.OrderBundleConfig.Seats",
  () => [
    { no: 1, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "seating" },
    { no: 2, name: "seat_ids", kind: "message", T: SeatIDs, oneof: "seating" },
  ],
  {localName: "OrderBundleConfig_Seats"},
);

/**
 * DiscountConfig is a configuration for a redeemed voucher or benfit for an order.
 *
 * @generated from message booking.types.v1.DiscountConfig
 */
export const DiscountConfig = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.DiscountConfig",
  () => [
    { no: 1, name: "voucher_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "reference" },
    { no: 2, name: "benefit_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "reference" },
    { no: 10, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "price_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * GiftcardConfig is a configuration for a giftcard that will be purchased.
 *
 * @generated from message booking.types.v1.GiftcardConfig
 */
export const GiftcardConfig = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.GiftcardConfig",
  () => [
    { no: 1, name: "balance", kind: "message", T: Money },
  ],
);

/**
 * SeatUpgradeConfig is a configuration for a seat upgrade that will be purchased.
 *
 * @generated from message booking.types.v1.SeatUpgradeConfig
 */
export const SeatUpgradeConfig = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.SeatUpgradeConfig",
  () => [
    { no: 1, name: "referenced_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "line_item_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "seat_upgrade", kind: "enum", T: proto3.getEnumType(SeatUpgrade) },
  ],
);

/**
 * PreorderConfig is a configuration for items in a preorder that will be purchased.
 *
 * @generated from message booking.types.v1.PreorderConfig
 */
export const PreorderConfig = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.PreorderConfig",
  () => [
    { no: 1, name: "preorder_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message booking.types.v1.PreorderPreview
 */
export const PreorderPreview = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.PreorderPreview",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_item_counts", kind: "message", T: OrderPreview_ItemCounts },
    { no: 4, name: "purchasable_item_counts", kind: "message", T: OrderPreview_ItemCounts },
    { no: 5, name: "customer_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "expiry", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message booking.types.v1.Preorder
 */
export const Preorder = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Preorder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "items", kind: "message", T: Preorder_Item, repeated: true },
    { no: 4, name: "refunds", kind: "message", T: Refund, repeated: true },
    { no: 5, name: "customer", kind: "message", T: Customer },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "expiry", kind: "message", T: Timestamp },
    { no: 8, name: "shipment_method", kind: "enum", T: proto3.getEnumType(ShipmentMethod), opt: true },
    { no: 9, name: "webshop_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message booking.types.v1.Preorder.Item
 */
export const Preorder_Item = /*@__PURE__*/ proto3.makeMessageType(
  "booking.types.v1.Preorder.Item",
  () => [
    { no: 1, name: "item", kind: "message", T: Order_LineItem },
    { no: 2, name: "purchased", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "Preorder_Item"},
);

